import React, { createContext, useContext, useState, ReactNode } from 'react';

interface Notification {
  message: string;
  flightId: string;
}

interface NotificationContextProps {
  notification: string | null;
  setNotification: React.Dispatch<React.SetStateAction<string | null>>;
  message: string | null;
  setMessage: React.Dispatch<React.SetStateAction<string | null>>;
}

const NotificationContext = createContext<NotificationContextProps | undefined>(undefined);

export function InternetStatusNotificationProvider({ children }: { children: ReactNode }) {
  const [notification, setNotification] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);

  return (
    <NotificationContext.Provider value={{ notification, setNotification, message, setMessage }}>
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotification() {
  const context = useContext(NotificationContext);
  if (context === undefined) {
    throw new Error('useNotification must be used inside NotificationProvider');
  }
  return context;
}
